export default __webpack_public_path__ + "static/media/bR.a4c843dd.svg";